import { render, staticRenderFns } from "./form-section.vue?vue&type=template&id=802a8bc6&scoped=true&"
import script from "./form-section.vue?vue&type=script&lang=js&"
export * from "./form-section.vue?vue&type=script&lang=js&"
import style0 from "./form-section.vue?vue&type=style&index=0&id=802a8bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802a8bc6",
  null
  
)

export default component.exports